// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initLockTool = function() {
    (function(_super) {
        coffeeExtends(LockTool, _super);
        function LockTool() {
            return LockTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(LockTool, 'lock');
        LockTool.label = 'Lock';
        LockTool.icon = 'lock';
        LockTool.tagName = 'lock';

        return LockTool;
    })(ContentTools.Tools.Bold);
};



// WEBPACK FOOTER //
// ./src/lib/contenttools/lock.js